module.exports = __webpack_public_path__ + "img/JEAN_LOUIS_AUBERT_20s.d5066c57.jpg";